/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "omg": {
        "nested": {
          "order_extensions": {
            "nested": {
              "tender_gated": {
                "nested": {
                  "TenderGatedAdjustmentExtension": {
                    "fields": {
                      "appliedByPaymentId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.omg?.nested?.order_extensions?.nested?.tender_gated?.nested?.TenderGatedAdjustmentExtension) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE TenderGatedAdjustmentExtension @ squareup/omg/tender-gated/extensions.proto at 14:1
 */
export const TenderGatedAdjustmentExtension = $root.lookupType('squareup.omg.order_extensions.tender_gated.TenderGatedAdjustmentExtension');
fixType(TenderGatedAdjustmentExtension);
Builder.createAndAttachToType(TenderGatedAdjustmentExtension);
